import { maintenanceAPI } from './api';

export const reporteService = {
    /**
     * Obtener estadísticas del dashboard de mantenimiento
     */
    getDashboardStats: async () => {
        const response = await maintenanceAPI.get('/reportes/stats');
        return response.data;
    },

    /**
     * Descargar reporte ejecutivo en Excel
     */
    descargarReporteEjecutivo: async () => {
        const response = await maintenanceAPI.get('/reportes/ejecutivo', {
            responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Reporte_Ejecutivo_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
};
